/* ==========================================================================
   OMBRE BLISS — INSTANT CAMPAIGN ENGINE & RESILIENT GOKWIK CONNECTOR
   - 100% Dynamic live product fetching categorized by size: 100ml & 25ml
   - Auto-recovery checkout button (never gets stuck on modal close)
   ========================================================================== */

(function(window, document) {
  'use strict';

  
  // Swipeable card gallery dot update & slide helpers
  window.obSetGalleryActiveDot = function(wrap, index) {
    if (!wrap) return;
    const dots = wrap.querySelectorAll('.ob-dot');
    dots.forEach((dot, idx) => {
      dot.classList.toggle('active', idx === index);
    });
  };

  window.obUpdateDots = function(el) {
    if (!el) return;
    const slideW = el.clientWidth || 1;
    const index = Math.min(
      Math.max(0, Math.round(el.scrollLeft / slideW)),
      Math.max(0, (el.children ? el.children.length : 1) - 1)
    );
    const wrap = el.closest('.imgwrap') || el.parentElement;
    window.obSetGalleryActiveDot(wrap, index);
  };

  window.obSlideGallery = function(btn, dir) {
    if (!btn) return;
    const wrap = btn.closest('.imgwrap');
    const gallery = wrap ? wrap.querySelector('.ob-card-gallery') : null;
    if (!gallery || !gallery.children.length) return;
    const slideW = gallery.clientWidth || (gallery.children[0] ? gallery.children[0].clientWidth : 1);
    const curIdx = Math.round(gallery.scrollLeft / slideW);
    const maxIdx = gallery.children.length - 1;
    let nextIdx = curIdx + dir;
    if (nextIdx < 0) nextIdx = maxIdx;
    else if (nextIdx > maxIdx) nextIdx = 0;

    const targetSlide = gallery.children[nextIdx];
    if (targetSlide) {
      targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    } else {
      gallery.scrollTo({ left: nextIdx * slideW, behavior: 'smooth' });
    }
    window.obSetGalleryActiveDot(wrap, nextIdx);
  };

  window.obGoToSlide = function(target, idx) {
    if (!target) return;
    const imgwrap = target.closest('.imgwrap');
    const gallery = imgwrap ? imgwrap.querySelector('.ob-card-gallery') : null;
    if (!gallery || !gallery.children[idx]) return;
    gallery.children[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    window.obSetGalleryActiveDot(imgwrap, idx);
  };

  window.obInitGalleryDrag = function(gallery) {
    if (!gallery || gallery.dataset.obDragInit === '1') return;
    gallery.dataset.obDragInit = '1';

    const imgwrap = gallery.closest('.imgwrap');

    // 1. Mobile & Touch: High-speed IntersectionObserver for 100% accurate dot tracking
    if ('IntersectionObserver' in window) {
      try {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              const slideIdx = parseInt(entry.target.getAttribute('data-index'), 10);
              if (!isNaN(slideIdx)) {
                window.obSetGalleryActiveDot(imgwrap, slideIdx);
              }
            }
          });
        }, {
          root: gallery,
          threshold: 0.5
        });

        Array.from(gallery.children).forEach((child, idx) => {
          child.setAttribute('data-index', idx);
          observer.observe(child);
        });
      } catch (e) {
        console.warn('[OB Gallery] Observer fallback:', e);
      }
    }

    // 2. Real-time scroll / scrollend event listeners
    let ticking = false;
    gallery.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          window.obUpdateDots(gallery);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    gallery.addEventListener('scrollend', function() {
      window.obUpdateDots(gallery);
    }, { passive: true });

    // 3. Desktop Drag-to-Swipe handling
    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let hasMoved = false;

    gallery.addEventListener('mousedown', function(e) {
      if (e.button !== 0) return;
      isDown = true;
      hasMoved = false;
      startX = e.pageX;
      startScrollLeft = gallery.scrollLeft;
      gallery.classList.add('is-dragging');
    });

    const onMouseMove = function(e) {
      if (!isDown) return;
      const dx = e.pageX - startX;
      if (Math.abs(dx) > 5) {
        hasMoved = true;
      }
      gallery.scrollLeft = startScrollLeft - dx;
    };

    const onMouseUp = function(e) {
      if (!isDown) return;
      isDown = false;
      gallery.classList.remove('is-dragging');

      const slideW = gallery.clientWidth || 1;
      const dx = e.pageX - startX;
      let targetIdx = Math.round(gallery.scrollLeft / slideW);
      if (hasMoved) {
        if (dx < -30) {
          targetIdx = Math.min(gallery.children.length - 1, Math.ceil(startScrollLeft / slideW) + (Math.round(gallery.scrollLeft / slideW) === Math.ceil(startScrollLeft / slideW) ? 1 : 0));
        } else if (dx > 30) {
          targetIdx = Math.max(0, Math.floor(startScrollLeft / slideW) - (Math.round(gallery.scrollLeft / slideW) === Math.floor(startScrollLeft / slideW) ? 1 : 0));
        }
      }
      targetIdx = Math.max(0, Math.min(gallery.children.length - 1, targetIdx));
      if (gallery.children[targetIdx]) {
        gallery.children[targetIdx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      } else {
        gallery.scrollTo({ left: targetIdx * slideW, behavior: 'smooth' });
      }
      window.obSetGalleryActiveDot(imgwrap, targetIdx);
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);

    gallery.addEventListener('click', function(e) {
      if (hasMoved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  };

  window.obInitAllGalleries = function(container) {
    const root = container || document;
    root.querySelectorAll('.ob-card-gallery').forEach(g => {
      window.obInitGalleryDrag(g);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.obInitAllGalleries());
  } else {
    window.obInitAllGalleries();
  }

    /* --------------------------------------------------------------------------
     FRAGRANCE NOTES DATABASE & 3-STAGE CARD STRIP WITH INGREDIENT IMAGES
     -------------------------------------------------------------------------- */
  const IB = 'https://cdn.shopify.com/s/files/1/0694/0478/6914/files/';

  const FAMIMG = {
    citrus: IB + 'lemon.webp?v=1782296301',
    pepper: IB + 'pepper.webp?v=1782294875',
    spice: IB + 'piecrec_Warm_spicy.webp?v=1742382749',
    wood: IB + 'cedar.webp?v=1782294875',
    moss: IB + 'vetiver_8ce949bd-93da-4b6a-98be-6439e1d4116e.webp?v=1782294875',
    oud: IB + 'agarwood.jpg?v=1742376493',
    leather: IB + 'leather.jpg?v=1742383224',
    tobacco: IB + 'Tobacco_Leaf.webp?v=1750158959',
    vanilla: IB + 'vanilla.jpg?v=1742376493',
    sugar: IB + 'sugar.webp?v=1742376493',
    nut: IB + 'almonds.webp?v=1782296301',
    cacao: IB + 'coffee.webp?v=1782296301',
    rose: IB + 'rose_888124a9-9de1-4f31-95d9-61efab00f24a.webp?v=1782297808',
    floral: IB + 'Jasmin_2010a34c-0b81-48f2-9871-b05c4b50a00c.webp?v=1782293377',
    amber: IB + 'woody-amber.webp?v=1782298796',
    musk: IB + 'benzoin_b41c289f-a5f0-4be4-b973-7a0d5464453d.webp?v=1782294875',
    tea: IB + 'sage.webp?v=1782297066',
    booze: IB + 'istockphoto-1140849064-612x612.jpg?v=1750152974',
    lavender: IB + 'geranium.webp?v=1782297066'
  };

  const NOTE_IMAGES = {
    'Clary Sage': IB + 'Clary_Sage.webp?v=1750158959',
    'Lemon': IB + 'Lemon_222.avif?v=1750159250',
    'Neroli': IB + 'Neroli.jpg?v=1750158959',
    'Pink Pepper': IB + 'pink-pepper-isolated-white-background_269410-1578.avif?v=1750157354',
    'Rum': IB + 'istockphoto-1140849064-612x612.jpg?v=1750152974',
    'Styrax': IB + 'Styrax.webp?v=1750158959',
    'Tobacco Leaf': IB + 'Tobacco_Leaf.webp?v=1750158959',
    'Vanilla Bean': IB + 'Vanilla_Bean.webp?v=1750158959',
    'Vetiver Oil': IB + 'Vetiver_Oil.jpg?v=1750158959',
    'Bergamot': IB + 'bergamot.webp?v=1782296301',
    'Jasmine': IB + 'Jasmin_2010a34c-0b81-48f2-9871-b05c4b50a00c.webp?v=1782293377',
    'Patchouli': IB + 'patchouli_fbf193f2-0d6d-4975-836e-ff7d6426c05a.webp?v=1782298796',
    'Vetiver': IB + 'vetiver_8ce949bd-93da-4b6a-98be-6439e1d4116e.webp?v=1782294875',
    'Sandalwood': IB + 'sandal_wood.jpg?v=1742376493',
    'Vanilla': IB + 'vanilla.jpg?v=1742376493',
    'Leather': IB + 'leather.jpg?v=1742383224',
    'Agarwood': IB + 'agarwood.jpg?v=1742376493',
    'Rose': IB + 'rose_888124a9-9de1-4f31-95d9-61efab00f24a.webp?v=1782297808'
  };

  const NF = {
    'Lemon': 'citrus', 'Citrus': 'citrus', 'Bergamot': 'citrus', 'Sicilian Orange': 'citrus',
    'Citron': 'citrus', 'Italian Mandarin': 'citrus', 'Mandarin Orange': 'citrus', 'Orange': 'citrus',
    'Grapefruit': 'citrus', 'Pink Pepper': 'pepper', 'Pepper': 'pepper', 'Cardamom': 'spice',
    'Ginger': 'spice', 'Cinnamon': 'spice', 'Spice Mix': 'spice', 'Angelica': 'spice',
    'Clary Sage': 'spice', 'Warm Spicy': 'spice', 'Warm Spicy Soft Spicy': 'spice',
    'Vetiver': 'wood', 'Vetiver Oil': 'wood', 'Sandalwood': 'wood', 'Guaiac Wood': 'wood',
    'Cashmeran': 'wood', 'Patchouli': 'wood', 'Galbanum': 'wood', 'Violet Leaves': 'wood',
    'Woody Amber': 'wood', 'Balsamic Woody': 'wood', 'Cedar': 'wood', 'Moss': 'moss',
    'Oud': 'oud', 'Agarwood': 'oud', 'Styrax': 'oud', 'Amber Oud': 'oud', 'Leather': 'leather',
    'Tobacco': 'tobacco', 'Tobacco Leaf': 'tobacco', 'Vanilla': 'vanilla', 'Vanilla Bean': 'vanilla',
    'Vanilla Fusion': 'vanilla', 'Vanilla Caviar': 'vanilla', 'Tonka Bean': 'vanilla',
    'Tonka Beans': 'vanilla', 'Brown Sugar': 'sugar', 'White Caramel': 'sugar', 'Rock Sugar': 'sugar',
    'Cotton Candy': 'sugar', 'Marshmallow': 'sugar', 'Bubble Gum': 'sugar', 'Candied Pear': 'sugar',
    'Gelato': 'sugar', 'Raspberry': 'sugar', 'Pear': 'sugar', 'Melon': 'sugar', 'Red Berries': 'sugar',
    'Pistachio': 'nut', 'Hazelnut': 'nut', 'Almonds': 'nut', 'Cacao': 'cacao', 'Cocoa': 'cacao',
    'Coffee': 'cacao', 'Rose': 'rose', 'Damask Rose': 'rose', 'Rose Bloom': 'rose',
    'Bulgarian Rose': 'rose', 'Rose Fruity': 'rose', 'Neroli': 'floral', 'Tunisian Neroli': 'floral',
    'Jasmine': 'floral', 'Sambac': 'floral', 'Peony': 'floral', 'Orchid': 'floral', 'Floral': 'floral',
    'Gardenia': 'floral', 'Pear Blossom': 'floral', 'Frangipani': 'floral', 'Orange Bloom': 'floral',
    'Geranium': 'floral', 'Amber': 'amber', 'Benzoin': 'amber', 'White Musk': 'musk',
    'Black Tea': 'tea', 'Basil': 'tea', 'Sage': 'tea', 'Cucumber': 'tea', 'Aromatic': 'tea',
    'Rum': 'booze', 'Lavender': 'lavender'
  };

  window.obGetNoteImg = function(noteName) {
    if (!noteName) return FAMIMG.wood;
    const clean = String(noteName).trim();
    if (NOTE_IMAGES[clean]) return NOTE_IMAGES[clean];
    for (const k in NOTE_IMAGES) {
      if (k.toLowerCase() === clean.toLowerCase()) return NOTE_IMAGES[k];
    }
    for (const k in NF) {
      if (k.toLowerCase() === clean.toLowerCase() || clean.toLowerCase().indexOf(k.toLowerCase()) !== -1) {
        return FAMIMG[NF[k]] || FAMIMG.wood;
      }
    }
    return FAMIMG.wood;
  };

  window.OB_SCENT_NOTES = {
    'smoky-rum': {
      title: 'Smoky Rum',
      top: ['Pink Pepper', 'Lemon', 'Neroli'],
      mid: ['Rum', 'Clary Sage', 'Vetiver Oil'],
      base: ['Tobacco Leaf', 'Vanilla Bean', 'Styrax']
    },
    'ombre-blu-perfume': {
      title: 'Ombre Blu',
      top: ['Bergamot', 'Sicilian Orange', 'Citron'],
      mid: ['Tunisian Neroli', 'Ginger', 'Cinnamon'],
      base: ['Black Tea', 'Guaiac Wood', 'Amber']
    },
    'classical-leather-perfume': {
      title: 'Classic Leather',
      top: ['Cardamom', 'Leather', 'Citrus'],
      mid: ['Jasmine', 'Sambac', 'Moss'],
      base: ['Vetiver', 'Patchouli', 'Amber']
    },
    'nawab-oud-perfume': {
      title: 'Nawab Oud',
      top: ['Oud', 'Bergamot', 'Neroli'],
      mid: ['Rose', 'Patchouli', 'Floral'],
      base: ['Amber', 'Vanilla Bean', 'Agarwood']
    },
    'angel-perfume': {
      title: 'Angel',
      top: ['Vanilla Fusion', 'Lavender', 'Cocoa'],
      mid: ['Ginger', 'Vanilla Caviar', 'Tonka Beans'],
      base: ['Spice Mix', 'Sandalwood', 'Amber']
    },
    'royale-tobacco-perfume': {
      title: 'Royale Tobacco',
      top: ['Cinnamon', 'Tobacco', 'Cardamom'],
      mid: ['Sandalwood', 'Patchouli', 'Floral'],
      base: ['Spice Mix', 'Vanilla', 'Tonka Bean']
    },
    'vanilla-kiss-perfume': {
      title: 'Vanilla Kiss',
      top: ['Vanilla', 'Orchid', 'Jasmine'],
      mid: ['Brown Sugar', 'Rum', 'Tonka Beans'],
      base: ['Oud', 'Patchouli', 'Amber']
    },
    'amber-rose-unisex-perfume': {
      title: 'Amber Rose',
      top: ['Bergamot', 'Galbanum', 'Pink Pepper'],
      mid: ['Damask Rose', 'Angelica', 'Amber'],
      base: ['White Musk', 'Cashmeran', 'Rose Bloom']
    },
    'pistachio-pop-perfume': {
      title: 'Pistachio Pop',
      top: ['Pistachio', 'Gelato', 'Hazelnut'],
      mid: ['Peony', 'Jasmine', 'Raspberry'],
      base: ['Cotton Candy', 'Marshmallow', 'Cacao']
    },
    'lush-candy-perfume': {
      title: 'Lush Candy',
      top: ['Candied Pear', 'Violet Leaves', 'Ylang Ylang'],
      mid: ['Jasmine', 'Bubble Gum', 'White Caramel'],
      base: ['Sandalwood', 'Patchouli', 'Rock Sugar']
    },
    'honour-perfume-for-him': {
      title: 'Honour',
      top: ['Orange', 'Grapefruit'],
      mid: ['Pepper', 'Jasmine'],
      base: ['Cedar', 'Vetiver', 'Benzoin']
    },
    'marino-perfume-for-him': {
      title: 'Marino',
      top: ['Cucumber', 'Melon', 'Mandarin Orange'],
      mid: ['Basil', 'Sage', 'Geranium'],
      base: ['Warm Spicy Soft Spicy', 'White Musk'],
      displayBase: ['Warm Spicy', 'White Musk']
    },
    'vicious-perfume-for-him': {
      title: 'Vicious',
      top: ['Amber', 'Oud', 'Warm Spicy'],
      mid: ['Fruity', 'Rose'],
      base: ['Leather', 'Woody Amber', 'Balsamic Woody']
    },
    'yazuka-perfume-for-him': {
      title: 'Yakuza',
      top: ['Agarwood', 'Oud'],
      mid: ['Sugar', 'Vanilla'],
      base: ['Agarwood', 'Sandalwood']
    },
    'the-bouquet-perfume-for-her': {
      title: 'The Bouquet',
      top: ['Pear Blossom', 'Red Berries'],
      mid: ['Gardenia', 'Jasmine', 'Frangipani'],
      base: ['Brown Sugar', 'Patchouli']
    },
    'obsessed-perfume-for-her': {
      title: 'Obsessed',
      top: ['Pear Blossom', 'Bergamot', 'Grapefruit'],
      mid: ['Orange Bloom', 'Jasmine', 'Frangipani'],
      base: ['Brown Sugar', 'Patchouli']
    },
    'luna-perfume-for-her': {
      title: 'Luna',
      top: ['Almonds', 'Coffee', 'Lemon'],
      mid: ['Bulgarian Rose', 'Orange'],
      base: ['Vanilla', 'Tonka Bean', 'Cacao']
    },
    'pierce-perfume-for-her': {
      title: 'Pierce',
      top: ['Warm Spicy Soft Spicy', 'Coffee'],
      mid: ['Woody Amber', 'Citrus'],
      base: ['Aromatic', 'Patchouli']
    },
    'luxury-perfume-gift-set-for-him-4-x-25mls': {
      title: 'Luxury Gift Set for Him',
      isGift: true,
      text: 'Curated set of 4 luxury perfumes (4 x 25ml) in a presentation box'
    },
    'luxury-perfume-gift-set-for-her-4-x-25mls': {
      title: 'Luxury Gift Set for Her',
      isGift: true,
      text: 'Curated set of 4 luxury perfumes (4 x 25ml) in a presentation box'
    }
  };

  function parseNotesToArray(val) {
    if (!val) return [];
    if (Array.isArray(val)) return val;
    return String(val)
      .replace(/\u00a0/g, ' ')
      .split(/[,·•|]/)
      .map(function(p) { return p.trim(); })
      .filter(Boolean);
  }

  window.obGetNotes = function(s) {
    if (!s) return null;
    const h = (s.handle || '').toLowerCase().trim();
    const name = (s.name || s.title || '').toLowerCase().replace(/[^a-z0-9]/g, '');

    // 1. Gift set check
    if (s.fam === 'Gift Set' || h.indexOf('gift-set') !== -1 || name.indexOf('giftset') !== -1) {
      return {
        isGift: true,
        text: 'Curated set of 4 luxury perfumes (4 x 25ml) in a presentation box'
      };
    }

    // 2. Direct key match
    if (window.OB_SCENT_NOTES && window.OB_SCENT_NOTES[h]) {
      const entry = window.OB_SCENT_NOTES[h];
      return {
        top: entry.top,
        mid: entry.mid,
        base: entry.base,
        isGift: entry.isGift || false,
        text: entry.text || ''
      };
    }

    // 3. Fuzzy match across keys
    if (window.OB_SCENT_NOTES) {
      for (const k in window.OB_SCENT_NOTES) {
        const kNorm = k.toLowerCase().replace(/[^a-z0-9]/g, '');
        if (h.indexOf(k) !== -1 || k.indexOf(h) !== -1 || name.indexOf(kNorm) !== -1 || kNorm.indexOf(name) !== -1) {
          const entry = window.OB_SCENT_NOTES[k];
          return {
            top: entry.top,
            mid: entry.mid,
            base: entry.base,
            isGift: entry.isGift || false,
            text: entry.text || ''
          };
        }
      }
    }

    // 4. Fallback to passed values
    return {
      top: parseNotesToArray(s.top).length ? parseNotesToArray(s.top) : ['Fresh Citrus', 'Light Spices'],
      mid: parseNotesToArray(s.mid).length ? parseNotesToArray(s.mid) : ['Velvet Florals', 'Heart Accord'],
      base: parseNotesToArray(s.base).length ? parseNotesToArray(s.base) : ['Warm Woods', 'Sensual Amber'],
      isGift: false
    };
  };

  window.OB_ACCORDS = {
    // Couture 100ml & 25ml
    'classical-leather-perfume': ['Leather', 'Floral', 'Spicy'],
    'smoky-rum': ['Tobacco', 'Rum', 'Woody'],
    'ombre-blu-perfume': ['Citrus', 'Fresh', 'Amber'],
    'nawab-oud-perfume': ['Oud', 'Woody', 'Patchouli'],
    'royale-tobacco-perfume': ['Cinnamon', 'Tonka', 'Tobacco'],
    'vanilla-kiss-perfume': ['Vanilla', 'Rum', 'Amber'],
    'amber-rose-unisex-perfume': ['Rose', 'Amber', 'Musk'],
    'angel-perfume': ['Lavender', 'Spicy', 'Cocoa'],
    'pistachio-pop-perfume': ['Nutty', 'Creamy', 'Sweet'],
    'lush-candy-perfume': ['Berries', 'Vanilla', 'Musk'],

    // Classic Collection
    'marino-perfume-for-him': ['Cucumber', 'Mandarin', 'Sage'],
    'vicious-perfume-for-him': ['Oud', 'Spice', 'Leather'],
    'yazuka-perfume-for-him': ['Agarwood', 'Vanilla', 'Sandalwood'],
    'yakuza-perfume-for-him': ['Agarwood', 'Vanilla', 'Sandalwood'],
    'honour-perfume-for-him': ['Citrus', 'Pepper', 'Cedar'],
    'the-bouquet-perfume-for-her': ['Pear', 'Gardenia', 'Jasmine'],
    'obsessed-perfume-for-her': ['Pear', 'Citrus', 'Rose'],
    'luna-perfume-for-her': ['Coffee', 'Almond', 'Rose'],
    'pierce-perfume-for-her': ['Aromatic', 'Coffee', 'Amber'],
    'pierce-unisex-perfume': ['Aromatic', 'Coffee', 'Amber'],

    // Gift Sets
    'luxury-perfume-gift-set-for-him-4-x-25mls': ['4 × 25ml', 'Curated', 'Luxury Set'],
    'luxury-perfume-gift-set-for-her-4-x-25mls': ['4 × 25ml', 'Curated', 'Luxury Set']
  };

  window.obGetAccordsList = function(s) {
    if (!s) return ['Luxury', 'Extrait', 'Perfume'];
    const h = (s.handle || '').toLowerCase().trim();
    const name = (s.name || s.title || '').toLowerCase().replace(/[^a-z0-9]/g, '');

    if (s.fam === 'Gift Set' || h.indexOf('gift-set') !== -1 || name.indexOf('giftset') !== -1) {
      return ['4 × 25ml', 'Curated', 'Luxury Set'];
    }

    if (window.OB_ACCORDS && window.OB_ACCORDS[h]) {
      return window.OB_ACCORDS[h];
    }

    if (window.OB_ACCORDS) {
      for (const k in window.OB_ACCORDS) {
        const kNorm = k.toLowerCase().replace(/[^a-z0-9]/g, '');
        if (h.indexOf(k) !== -1 || k.indexOf(h) !== -1 || name.indexOf(kNorm) !== -1 || kNorm.indexOf(name) !== -1) {
          return window.OB_ACCORDS[k];
        }
      }
    }

    let raw = s.short || s.fam || '';
    if (raw) {
      const parts = raw.split(/[|·•,]/).map(function(p) { return p.trim(); }).filter(Boolean);
      if (parts.length >= 1) return parts.slice(0, 3);
    }

    return ['Extrait', 'Long Lasting', 'Unisex'];
  };

  window.obSetCardStage = function() {};
  window.obHoverNote = function() {};
  window.obLeaveNote = function() {};
  window.obToggleNote = function() {};
  window.obHighlightNote = function() {};
  window.obResetNote = function() {};

  window.obRenderCardNotes = function(s) {
    const list = window.obGetAccordsList(s);
    const pillsHtml = list.map(function(acc) {
      return '<span class="ob-prof-pill" title="' + acc + '">' + acc + '</span>';
    }).join('');

    return '<div class="ob-card-profile">' + pillsHtml + '</div>';
  };

  window.OBCampaignEngine = {
    _cachedProducts: null,

    async getLiveProducts() {
      if (this._cachedProducts) {
        return this._cachedProducts;
      }

      const has100 = Array.isArray(window.OB_LIVE_100ML_PRODUCTS) && window.OB_LIVE_100ML_PRODUCTS.length > 0;
      const has25 = Array.isArray(window.OB_LIVE_25ML_PRODUCTS) && window.OB_LIVE_25ML_PRODUCTS.length > 0;
      const hasClassic = Array.isArray(window.OB_LIVE_CLASSIC_100ML) && window.OB_LIVE_CLASSIC_100ML.length > 0;

      if (has100 && has25) {
        this._cachedProducts = {
          p100: window.OB_LIVE_100ML_PRODUCTS,
          p25: window.OB_LIVE_25ML_PRODUCTS,
          couture: window.OB_LIVE_COUTURE_100ML || window.OB_LIVE_100ML_PRODUCTS,
          classic: hasClassic ? window.OB_LIVE_CLASSIC_100ML : (window.OB_LIVE_CLASSIC_PRODUCTS || window.OB_LIVE_100ML_PRODUCTS)
        };
        this._fetchStorefrontProducts(false);
        return this._cachedProducts;
      }

      return await this._fetchStorefrontProducts(true);
    },

    async _fetchStorefrontProducts(blocking = true) {
      try {
        const res = await fetch('/products.json?limit=250', {
          method: 'GET',
          headers: { 'Accept': 'application/json' }
        });
        if (!res.ok) throw new Error('Failed to fetch /products.json: ' + res.status);
        const data = await res.json();
        const rawProducts = data.products || [];

        const p100 = [];
        const p25 = [];

        rawProducts.forEach(p => {
          const title = p.title || '';
          const titleLower = title.toLowerCase();
          const tags = Array.isArray(p.tags) ? p.tags.map(t => t.toLowerCase()) : [];
          const handle = (p.handle || '').toLowerCase();

          const isGiftSet = (handle.includes('luxury-perfume-gift-set') || handle.includes('gift-set') || titleLower.includes('gift set')) &&
            !tags.includes('free-gift') && !tags.includes('hidden') && !handle.includes('free') && !titleLower.includes('free');

          if (!isGiftSet) {
            // Skip promotional bundles, freebies
            if (tags.some(t => ['bundle', 'hidden', 'kwikcart-freebie', 'free-gift', 'gift'].includes(t)) ||
                ['mix-match', 'pick-any', 'fathers-day', 'free-25ml', 'free-100ml', 'free-luxury', 'gift-with-every-order', 'gift-set', 'giftset'].some(k => handle.includes(k)) ||
                titleLower.includes('gift set') || titleLower.includes('gift-set') || titleLower.includes('free') ||
                titleLower.includes('flash sale') || titleLower.includes('pick any') || titleLower.includes('bundle')) {
              return;
            }
          }

          const rawImg = p.images && p.images.length > 0 ? p.images[0].src : '';
          const img = rawImg ? (rawImg.split('?')[0] + '?width=400') : '';
          const name = title.split('–')[0].split('-')[0].split('|')[0].trim();

          const sNotes = (window.obGetNotes ? window.obGetNotes({ handle: p.handle, title: title, name: name }) : null) || {};
          let notes = sNotes.top || '';
          if (isGiftSet) {
            notes = 'Curated set of 4 signature perfumes (4 x 25ml) in a luxury box';
          } else if (p.body_html && !notes) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = p.body_html;
            notes = (tempDiv.textContent || tempDiv.innerText || '').slice(0, 70).trim();
          }

          const isCouture = !isGiftSet && (titleLower.includes('extrait') || tags.includes('couture'));
          const fam = isGiftSet ? 'Gift Set' : (isCouture ? 'Extrait De Parfum' : 'Eau De Parfum');

          let v100 = null; let v100_avail = true; let v25_avail = true; let v25_img_id = null;
          let pr100 = 1499;
          let v25 = null;
          let pr25 = 499;

          if (p.variants && p.variants.length > 0) {
            p.variants.forEach(v => {
              const vt = (v.title || '').toLowerCase();
              if (vt.includes('100') || vt.includes('default')) {
                v100 = String(v.id); v100_avail = (v.available !== false);
                pr100 = parseFloat(v.price) || 1499;
              }
              if (vt.includes('25')) {
                v25 = String(v.id); v25_avail = (v.available !== false);
                pr25 = parseFloat(v.price) || 499;
                v25_img_id = v.image_id;
              }
            });
            if (!v100 && p.variants.length === 1) {
              v100 = String(p.variants[0].id);
              pr100 = parseFloat(p.variants[0].price) || 1499;
            }
          }

          const allImgs100 = (p.images && p.images.length > 0)
            ? p.images.slice(0, 7).map(im => (im.src ? im.src.split('?')[0] + '?width=400' : ''))
            : [img];
          if (img && !allImgs100.includes(img)) allImgs100.unshift(img);
          const cleanImgs100 = Array.from(new Set(allImgs100.filter(Boolean)));

          if (v100) {
            p100.push({
              id: p.id,
              name: name,
              title: title,
              handle: p.handle,
              fam: fam,
              top: sNotes.top || '',
              mid: sNotes.mid || '',
              base: sNotes.base || '',
              notes: sNotes.top || notes || 'Long-lasting luxury fragrance',
              img: img,
              images: cleanImgs100,
              variantId: v100,
              price: pr100,
              size: isGiftSet ? '4 x 25 ml' : '100 ml',
              rev: isGiftSet ? 98 : 85,
              available: v100_avail
            });
          }

          if (v25) {
            let v25_img = img;
            if (p.images && p.images.length > 0) {
              const v25_num = parseInt(v25, 10);
              const matched = p.images.find(im => 
                (im.variant_ids && im.variant_ids.includes(v25_num)) ||
                (v25_img_id && im.id === v25_img_id)
              );
              if (matched && matched.src) {
                v25_img = matched.src.split('?')[0] + '?width=400';
              }
            }
            const cleanImgs25 = [v25_img, ...cleanImgs100.filter(x => x !== v25_img)];
            p25.push({
              id: p.id,
              name: name,
              title: title,
              handle: p.handle,
              fam: fam,
              top: sNotes.top || '',
              mid: sNotes.mid || '',
              base: sNotes.base || '',
              notes: sNotes.top || notes || 'Compact pocket-size luxury fragrance',
              img: v25_img,
              images: Array.from(new Set(cleanImgs25.filter(Boolean))),
              variantId: v25,
              price: pr25,
              size: '25 ml',
              rev: 85,
              available: v25_avail
            });
          }
        });

        const classicItems = (window.OB_LIVE_CLASSIC_100ML && window.OB_LIVE_CLASSIC_100ML.length > 0)
          ? window.OB_LIVE_CLASSIC_100ML
          : p100.filter(x => x.fam !== 'Extrait De Parfum').map(item => {
              if (item.fam === 'Gift Set' || (item.title && item.title.toLowerCase().includes('gift set'))) {
                return Object.assign({}, item, { price: 699 });
              }
              return item;
            });

        this._cachedProducts = {
          p100,
          p25,
          couture: p100.filter(x => x.fam === 'Extrait De Parfum'),
          classic: classicItems
        };
        window.OB_LIVE_100ML_PRODUCTS = p100;
        window.OB_LIVE_25ML_PRODUCTS = p25;
        window.OB_LIVE_COUTURE_PRODUCTS = this._cachedProducts.couture;
        window.OB_LIVE_CLASSIC_PRODUCTS = classicItems;

        window.dispatchEvent(new CustomEvent('ob:products:loaded', { detail: this._cachedProducts }));
        return this._cachedProducts;
      } catch (err) {
        console.warn('[OB Campaign Engine] Live product fetch warning:', err);
        return {
          p100: window.OB_LIVE_100ML_PRODUCTS || [],
          p25: window.OB_LIVE_25ML_PRODUCTS || []
        };
      }
    },

    async checkout({ items, discountCode, btnEl, bundleName, loadingText = 'Applying Deal...', successText = 'Opening Checkout...' }) {
      if (!items || items.length === 0) return;

      const originalBtnText = btnEl ? (btnEl.dataset.originalHtml || btnEl.innerHTML) : '';
      if (btnEl && !btnEl.dataset.originalHtml) {
        btnEl.dataset.originalHtml = originalBtnText;
      }
      if (btnEl) {
        btnEl.disabled = true;
        btnEl.innerHTML = `<span style="display:inline-flex;align-items:center;gap:6px;"><svg style="width:16px;height:16px;animation:obSpin 1s linear infinite" viewBox="0 0 24 24"><circle cx="12" cy="10" r="10" fill="none" stroke="currentColor" stroke-width="3" stroke-dasharray="32" stroke-linecap="round"/></svg> ${loadingText}</span>`;
      }

      const restoreButton = () => {
        window._gokwikLock = false;
        if (btnEl) {
          btnEl.disabled = false;
          btnEl.classList.remove('processing', 'gokwik-marge');
          delete btnEl.dataset.gokwikProcessed;
          if (btnEl.dataset.originalHtml) {
            btnEl.innerHTML = btnEl.dataset.originalHtml;
          }
        }
        if (typeof window.obByobRender === 'function') {
          window.obByobRender();
        } else if (typeof window.obRenderState === 'function') {
          window.obRenderState();
        }
        document.querySelectorAll('.buy-btn, #ob-buy-btn, [id^="ob-buy-btn"]').forEach(b => {
          b.disabled = false;
          b.classList.remove('processing');
        });
      };
      window.obActiveRestoreButton = restoreButton;

      const onFocus = () => setTimeout(restoreButton, 300);
      const onVis = () => { if (document.visibilityState === 'visible') setTimeout(restoreButton, 300); };
      const onMsg = (e) => {
        try {
          const str = (typeof e.data === 'string' ? e.data : JSON.stringify(e.data || {})).toLowerCase();
          if (str.includes('close') || str.includes('cancel') || str.includes('dismiss') || str.includes('hide') || str.includes('exit')) {
            restoreButton();
          }
        } catch(err) {}
      };

      window.addEventListener('focus', onFocus, { once: true });
      document.addEventListener('visibilitychange', onVis, { once: true });
      window.addEventListener('pagehide', restoreButton, { once: true });
      window.addEventListener('message', onMsg);
      setTimeout(restoreButton, 3500);

      try {
        // 1. Clear cart FIRST so old items don't interfere
        try {
          await fetch('/cart/clear.js', { method: 'POST' });
        } catch (e) {}

        // 2. Add bundle items to cart
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: items.map(item => ({
              id: item.id,
              quantity: item.quantity,
              properties: Object.assign({
                '_campaign_source': 'landing_page',
                '_bundle': bundleName || 'Special Offer'
              }, item.properties || {})
            }))
          })
        });

        if (!addResponse.ok) {
          const errData = await addResponse.json();
          throw new Error(errData.description || 'Could not add items to cart');
        }

        // 3. Apply discount to active cart and update cart attributes
        let cartData = null;
        try {
          const updatePayload = {
            attributes: {
              '_campaign_bundle': bundleName || 'Special Offer',
              '_discount_applied': discountCode || ''
            }
          };
          if (discountCode) {
            updatePayload.discount = discountCode;
          }
          const cartRes = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(updatePayload)
          });
          if (cartRes.ok) cartData = await cartRes.json();
        } catch (e) {}

        // 4. Fetch discount URL AFTER cart has items so session is actively discounted
        if (discountCode) {
          try {
            await fetch('/discount/' + encodeURIComponent(discountCode), {
              method: 'GET',
              credentials: 'same-origin'
            });
            localStorage.setItem('applied_discount', discountCode);
            localStorage.setItem('ob_applied_coupon', discountCode);
            sessionStorage.setItem('discount_code', discountCode);
          } catch (e) {}
        }

        try {
          if (!cartData) {
            const cRes = await fetch('/cart.js');
            cartData = await cRes.json();
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cartData } }));
          window.dispatchEvent(new CustomEvent('ob:cart:change', { detail: { cart: cartData } }));
        } catch (e) {}

        if (btnEl) {
          btnEl.innerHTML = `<span style="color:#fff;font-weight:700;">${successText}</span>`;
        }

        const fallbackUrl = discountCode 
          ? `/discount/${encodeURIComponent(discountCode)}?redirect=/checkout`
          : '/checkout';

        // Open GoKwik Side Cart directly on the same page (NO redirect to homepage or /cart)
        function openSideCartOnCurrentPage() {
          if (typeof window.refreshSideCart === 'function') {
            try { window.refreshSideCart(); } catch(e) {}
          }
          if (typeof window.openGokwikSideCart === 'function') {
            try {
              window.openGokwikSideCart();
              return true;
            } catch(e) {}
          }
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            try {
              drawer.open();
              return true;
            } catch(e) {}
          }
          const cartBubble = document.getElementById('cart-icon-bubble') ||
                             document.querySelector('[data-cart-sidebar]') ||
                             document.querySelector('.header__icon--cart');
          if (cartBubble) {
            try {
              cartBubble.click();
              return true;
            } catch(e) {}
          }
          return false;
        }

        if (btnEl) {
          btnEl.disabled = false;
          btnEl.classList.remove('processing');
          btnEl.innerHTML = '<span style="color:#fff;font-weight:700;">View in Cart ✓</span>';
          btnEl.onclick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            openSideCartOnCurrentPage();
          };
        }

        openSideCartOnCurrentPage();
        setTimeout(openSideCartOnCurrentPage, 250);
        setTimeout(openSideCartOnCurrentPage, 600);
      } catch (err) {
        console.error('[OB Campaign] Checkout error:', err);
        alert(err.message || 'Something went wrong while applying your offer. Please try again.');
        restoreButton();
      }
    }
  };

  // Global bfcache & navigation restore listeners so returning from checkout NEVER leaves buttons stuck
  window.addEventListener('pageshow', function(event) {
    window._gokwikLock = false;
    if (typeof window.obActiveRestoreButton === 'function') {
      window.obActiveRestoreButton();
    }
    if (typeof window.obByobRender === 'function') {
      window.obByobRender();
    }
    if (typeof window.obRenderState === 'function') {
      window.obRenderState();
    }
    document.querySelectorAll('.buy-btn, #ob-buy-btn, [id^="ob-buy-btn"]').forEach(function(b) {
      b.disabled = false;
      b.classList.remove('processing');
      if (b.dataset.originalHtml) b.innerHTML = b.dataset.originalHtml;
    });
    window.dispatchEvent(new CustomEvent('ob:page:restored'));
  });

  window.addEventListener('pagehide', function() {
    if (typeof window.obActiveRestoreButton === 'function') {
      window.obActiveRestoreButton();
    }
  });

  function obCheckAndRestoreIfVisible() {
    if (document.visibilityState === 'visible') {
      const hasModal = document.querySelector('.gokwik-iframe-container, #gokwik-iframe, .gk-modal, iframe[id*="gokwik"], iframe[src*="gokwik"]');
      if (!hasModal) {
        window._gokwikLock = false;
        if (typeof window.obActiveRestoreButton === 'function') window.obActiveRestoreButton();
        if (typeof window.obByobRender === 'function') window.obByobRender();
        if (typeof window.obRenderState === 'function') window.obRenderState();
      }
    }
  }

  document.addEventListener('visibilitychange', () => setTimeout(obCheckAndRestoreIfVisible, 300));
  window.addEventListener('focus', () => setTimeout(obCheckAndRestoreIfVisible, 300));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.OBCampaignEngine.getLiveProducts());
  } else {
    window.OBCampaignEngine.getLiveProducts();
  }

})(window, document);
